var _filter, _marker, _marker2, _marker3, _rect, _text, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg09OfferAnswer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "offerGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d97706"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "answerGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iceGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerAGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4f46e5"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerBGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowOffer",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.25
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowOffer",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#fbbf24"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowAnswer",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#34d399"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowIce",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#22d3ee"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    Offer/Answer &amp; ICE Exchange\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 160)",
    filter: "url(#shadowOffer)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -80,
    width: 200,
    height: 160,
    rx: 20,
    fill: "url(#peerAGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -40,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "Browser A"), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#c7d2fe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "(Initiator/Caller)"), /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: 0,
    width: 170,
    height: 55,
    rx: 6,
    fill: "#1e1b4b"
  }), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 18,
    fill: "#fbbf24",
    fontFamily: "monospace",
    fontSize: 9
  }, "const offer = await"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 32,
    fill: "#a5b4fc",
    fontFamily: "monospace",
    fontSize: 9
  }, "  pc.createOffer();"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 46,
    fill: "#a5b4fc",
    fontFamily: "monospace",
    fontSize: 9
  }, "pc.setLocalDescription(offer);"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(770, 160)",
    filter: "url(#shadowOffer)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -80,
    width: 200,
    height: 160,
    rx: 20,
    fill: "url(#peerBGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -40,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "Browser B"), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#ddd6fe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "(Receiver/Callee)"), /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: 0,
    width: 170,
    height: 55,
    rx: 6,
    fill: "#2e1065"
  }), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 18,
    fill: "#34d399",
    fontFamily: "monospace",
    fontSize: 9
  }, "const answer = await"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 32,
    fill: "#c4b5fd",
    fontFamily: "monospace",
    fontSize: 9
  }, "  pc.createAnswer();"), /*#__PURE__*/React.createElement("text", {
    x: -75,
    y: 46,
    fill: "#c4b5fd",
    fontFamily: "monospace",
    fontSize: 9
  }, "pc.setLocalDescription(answer);"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 250 130 Q 450 80 650 130",
    stroke: "#fbbf24",
    strokeWidth: 4,
    fill: "none",
    markerEnd: "url(#arrowOffer)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;400,500",
    dur: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 90)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -25,
    width: 140,
    height: 50,
    rx: 10,
    fill: "url(#offerGrad)",
    filter: "url(#shadowOffer)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -3,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "SDP OFFER"), /*#__PURE__*/React.createElement("text", {
    y: 15,
    textAnchor: "middle",
    fill: "#fef3c7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "Codecs, Media, Network")), /*#__PURE__*/React.createElement("circle", {
    r: 15,
    fill: "#f59e0b",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    path: "M 250 130 Q 450 80 650 130"
  })), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 105,
    fill: "#fbbf24",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "\u2460"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 650 200 Q 450 250 250 200",
    stroke: "#34d399",
    strokeWidth: 4,
    fill: "none",
    markerEnd: "url(#arrowAnswer)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,500;400,500",
    dur: "1s",
    fill: "freeze",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -25,
    width: 140,
    height: 50,
    rx: 10,
    fill: "url(#answerGrad)",
    filter: "url(#shadowOffer)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -3,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "SDP ANSWER"), /*#__PURE__*/React.createElement("text", {
    y: 15,
    textAnchor: "middle",
    fill: "#d1fae5",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "Accepted Parameters")), /*#__PURE__*/React.createElement("circle", {
    r: 15,
    fill: "#10b981",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M 650 200 Q 450 250 250 200"
  })), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 175,
    fill: "#34d399",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "\u2461"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 380)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -350,
    y: -60,
    width: 700,
    height: 120,
    rx: 16,
    fill: "#164e63",
    opacity: 0.3,
    stroke: "#06b6d4",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  }), /*#__PURE__*/React.createElement("text", {
    y: -30,
    textAnchor: "middle",
    fill: "#22d3ee",
    fontFamily: "system-ui, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "\u2462 ICE Candidate Exchange"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "#06b6d4"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    path: "M -250 20 L 250 20"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "#0891b2"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M -250 20 L 250 20"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "#67e8f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    path: "M 250 40 L -250 40"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "#a5f3fc"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.5s",
    path: "M 250 40 L -250 40"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: -250,
    y1: 20,
    x2: 250,
    y2: 20,
    stroke: "#22d3ee",
    strokeWidth: 2,
    strokeDasharray: "6,3",
    markerEnd: "url(#arrowIce)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 40,
    x2: -250,
    y2: 40,
    stroke: "#67e8f9",
    strokeWidth: 2,
    strokeDasharray: "6,3",
    markerEnd: "url(#arrowIce)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -180,
    y: -30,
    width: 360,
    height: 60,
    rx: 12,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("text", {
    y: -5,
    textAnchor: "middle",
    fill: "#a5f3fc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "ICE Candidate Contains:"), /*#__PURE__*/React.createElement("text", {
    y: 18,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "monospace",
    fontSize: 10
  }, "\n      IP Address | Port | Protocol (UDP/TCP) | Priority\n    "))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 560)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -150,
    y: -25,
    width: 300,
    height: 50,
    rx: 25,
    fill: "#022c22",
    stroke: "#22c55e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#4ade80",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "\n      \u2713 Connection Ready for P2P!\n    "))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -12,
    width: 160,
    height: 24,
    rx: 6,
    fill: "#312e81"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontFamily: "monospace",
    fontSize: 9
  }, "setRemoteDescription(answer)"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(770, 310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -12,
    width: 160,
    height: 24,
    rx: 6,
    fill: "#4c1d95"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "monospace",
    fontSize: 9
  }, "setRemoteDescription(offer)"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09OfferAnswer);
export default __webpack_public_path__ + "static/media/09-offer-answer.b772a176ca47eedfc743b1b95e20cbb4.svg";
export { ForwardRef as ReactComponent };